module.exports = {"540602100":"那曲镇","540602101":"罗玛镇","540602102":"古露镇","540602200":"达萨乡","540602202":"油恰乡","540602203":"香茂乡","540602205":"那么切乡","540602209":"达前乡","540602210":"劳麦乡","540602211":"孔玛乡","540602213":"尼玛乡","540602217":"色雄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540602.json
// module id = 2871
// module chunks = 0